export const INCLUDE_STATE = 'INCLUDE_STATE';

export const includeState = ({ action }) => ({
  type: INCLUDE_STATE,
  action,
});
